(function () {
  const updateLikeButton = (button, isLiked) => {
    button.setAttribute('aria-pressed', String(isLiked));
    button.classList.toggle('is-liked', isLiked);
    const label = button.querySelector('[data-article-like-label]');
    if (label) label.textContent = isLiked ? 'Liked' : 'Like';
  };

  const initializeLikeButton = (button) => {
    if (button.dataset.engagementReady === 'true') return;
    const articleId = button.dataset.articleId;
    if (!articleId) return;

    const storageKey = `filazoo:article-liked:${articleId}`;
    let isLiked = false;
    try {
      isLiked = window.localStorage.getItem(storageKey) === 'true';
    } catch (error) {
      isLiked = false;
    }
    updateLikeButton(button, isLiked);

    button.addEventListener('click', () => {
      isLiked = !isLiked;
      try {
        if (isLiked) window.localStorage.setItem(storageKey, 'true');
        else window.localStorage.removeItem(storageKey);
      } catch (error) {
        // The control still works for the current page when storage is unavailable.
      }
      updateLikeButton(button, isLiked);
    });
    button.dataset.engagementReady = 'true';
  };

  const fallbackCopy = (value) => {
    const input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
  };

  const initializeCopyButton = (button) => {
    if (button.dataset.engagementReady === 'true') return;
    button.addEventListener('click', async () => {
      const value = button.dataset.copyArticleUrl;
      if (!value) return;

      try {
        if (navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText(value);
        else fallbackCopy(value);
      } catch (error) {
        fallbackCopy(value);
      }

      const status = button.closest('.article-share-links')?.querySelector('[data-copy-article-status]');
      if (status) {
        status.textContent = 'Article link copied.';
        window.setTimeout(() => {
          status.textContent = '';
        }, 2500);
      }
    });
    button.dataset.engagementReady = 'true';
  };

  const initializeArticleEngagement = (root = document) => {
    root.querySelectorAll('[data-article-like]').forEach(initializeLikeButton);
    root.querySelectorAll('[data-copy-article-url]').forEach(initializeCopyButton);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeArticleEngagement());
  } else {
    initializeArticleEngagement();
  }

  document.addEventListener('shopify:section:load', (event) => initializeArticleEngagement(event.target));
})();
